class countdownTimerPopup extends HTMLElement {
  constructor() {
    super();
    this.close = this.querySelector('.countdown-timer-popup__close-button');
    let timerEndDate = new Date(this.querySelector('countdown-timer').dataset.endDate).getTime();
    let timerCurrentDate = new Date().getTime();
    let distance = timerEndDate - timerCurrentDate;
    let countdownTimerPopupStatus = sessionStorage.getItem('countdownTimerPopup');
    let hasVisitedProductPage = sessionStorage.getItem('hasVisitedProductPage');
    this.hasShown = false;

    if (countdownTimerPopupStatus != 'closed' && distance > 0) {
      if (hasVisitedProductPage === 'true') {
        setTimeout(() => {
          this.show();
          this.hasShown = true;
        }, 5000);
      } else {
        window.addEventListener('scroll', () => {
          this.checkIfShouldShow();
        });
      }
    }

    this.addEventListener('click', (event) => {
      if (event.target.closest('.countdown-timer-popup__close-button') || event.target === this) {
        this.hide();
      }
    });
  }

  checkIfShouldShow() {
    let countdownTimerPopupStatus = sessionStorage.getItem('countdownTimerPopup');
    let hasVisitedProductPage = sessionStorage.getItem('hasVisitedProductPage');
    if (this.hasShown || countdownTimerPopupStatus === 'closed') return;

    if (hasVisitedProductPage === 'true') {
      this.show();
      this.hasShown = true;
      window.removeEventListener('scroll', () => this.checkIfShouldShow());
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPercentage = (scrollTop + windowHeight) / documentHeight;

    if (scrollPercentage >= 0.5) {
      this.show();
      this.hasShown = true;
      window.removeEventListener('scroll', () => this.checkIfShouldShow());
    }
  }

  show() {
    this.classList.add('show_timer');
    document.body.classList.add('overflow-hidden');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.classList.remove('show_timer');
    sessionStorage.setItem('countdownTimerPopup', 'closed');
  }
}

customElements.define('popup-timer', countdownTimerPopup);
